/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{list-style:none;margin:0;padding:0;position:relative;display:flex;z-index:12}[_nghost-%COMP%]   a[_ngcontent-%COMP%]{width:160px;display:block;padding:.2rem .6rem;overflow:hidden;text-overflow:ellipsis}[_nghost-%COMP%]   .item-container[_ngcontent-%COMP%]{float:left}[_nghost-%COMP%]   a[_ngcontent-%COMP%]:hover{outline:0;border-radius:3px}  .ui-fileupload-content{height:80%;overflow:auto;border:0}.editor-sidebar-inner[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{padding:.5rem}"];
export { styles as styles };
